export default __webpack_public_path__ + "static/media/CPD Course Title- Pro Ride Cycling Instructor Workshop (1 day) flyer.b825c0f7.pdf";